// extracted by mini-css-extract-plugin
export default {"list":"ArticleList_list__WBJZS","list__empty":"ArticleList_list__empty__vgY8S","list__cards":"ArticleList_list__cards__J8aXJ"};